export enum RepairId {
  OtherDeviceDiagnosticService = 4619,
}
